module.exports = __webpack_public_path__ + "static/media/25_travel_the_world.1a9e7605.svg";